import { render } from "./TuoManage.vue?vue&type=template&id=c207fe1a&scoped=true"
import script from "./TuoManage.vue?vue&type=script&lang=js"
export * from "./TuoManage.vue?vue&type=script&lang=js"

import "./TuoManage.vue?vue&type=style&index=0&id=c207fe1a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c207fe1a"]])

export default __exports__